import {getInnerText} from "../utils/TS/Utils";

interface String {
  clearString(): string;
  clearCurrency(): string;
}

/** Formato especifico de texto para implementacion de GA4
 * El valor esperado por cada parámetro; siempre deberá estar en minúsculas y sin los siguientes signos ortográficos:
      - Acentuación (tildes, diéresis)
      - Entonación (exclamación, interrogación)
      - Pausas (punto, punto y coma)
      - Citas textuales (comillas)
      - Aclaraciones (paréntesis, corchetes, llaves)
 */
String.prototype.clearString = function () {
  
  if(typeof this == null) return ''; //'val is neither null nor undefined'

  const caracteresAcentuacionUnicode = /[\u0300,\u0301,\u0308]/g;
  const caracteresEntonacionUnicode = /[\u0021,\u00A1,\u003F,\u00BF]/g;
  const caracteresPausasUnicode = /[\u002E,\u003B]/g;
  const caracteresCitasUnicode = /[\u0022]/g;
  const caracteresAclaracionesUnicode = /[\u0028,\u0029,\u007B,\u007D,\u005B,\u005D]/g;

  const value = (this).toString();

  return getInnerText(value).replace(caracteresAcentuacionUnicode, "")
    .replace(caracteresEntonacionUnicode, "")
    .replace(caracteresPausasUnicode, "")
    .replace(caracteresCitasUnicode, "")
    .replace(caracteresAclaracionesUnicode, "")
    .replace(/&#(d+);/g, function(match, dec) { 
      return String.fromCharCode(dec);})
    .toLowerCase();
};

String.prototype.clearCurrency = function () {
  /**
      Los parámetros, que extraigan un valor numérico no pueden traer los siguientes signos:
      - Signo pesos, dolares, euros entre otros (divisa)
      - Separación de miles y millones con comas								
       */

  const currency = /[^0-9\.-]+/g;
  return this.replace(currency, "");
}



// WEBPACK FOOTER //
// ./src/extensions/string.extensions.ts